<template>
  <div class="help">
    <div class="comtent" v-if="customHelp">
      <h2 class="title">智慧停车开放平台帮助中心</h2>
      <div class="helpMsg">
        <div class="item">
          <h2>如何确定需要哪些接口?</h2>
          <p>
            智慧停车开放平台研发人员会根据您的需求确认对应的接口，如有需求请联系智慧停车客服电话
            <a :href="`tel://${customHelp.tel}`">{{ customHelp.tel }}</a>
            ，我们会安排专业人员跟您对接确认需求。
          </p>
        </div>调试该接口
        <div class="item">
          <h2>如何申请开通接入智慧停车开放平台?</h2>
          <p>
            <span v-if="customHelp.applyDocUrl">
            下载
              <a :href="customHelp.applyDocUrl">{{ customHelp.applyName }}</a>,填写相关信息后, 跳转到
            </span>
            <a class="linkA" @click="jump" href="javascript:;">申请指引</a>
            ，根据指引到 艾联客 提交申请
          </p>
        </div>
        <div class="item">
          <h2>如何调试上报类接口?</h2>
          <p>
            进出场上报请使用进场模拟/出场模拟接口，其它接口调试暂时请联系智慧停车开放平台研发团队。
          </p>
        </div>
      </div>
    </div>
    <div class="comtent" v-else>
      <h2 class="title">智慧停车开放平台帮助中心</h2>
      <div class="helpMsg">
        <div class="item">
          <h2>如何确定需要哪些接口?</h2>
          <p>
            智慧停车开放平台研发人员会根据您的需求确认对应的接口，如有需求请联系智慧停车客服电话
            <a href="tel://4006823828">400-682-3828</a>，我们会安排专业人员跟您对接确认需求。
            <!-- 智慧停车开放平台是一个平台，通过将复杂的通讯功能封装成SDK和API接口， 为合作伙伴提供IM、音频、视频、会议 呼叫中心、短信、流量等通讯能力及服务。 云通讯提供了近300个免费接口供合作伙伴调用，可以轻松实现即时通信（IM）、语音通话、语音通知、语音对讲、语 音会议、视频通话、视频会议、呼叫中心、智能IVR等20多种专业通讯功能。 -->
          </p>
        </div>
        <div class="item">
          <h2>如何申请开通智慧停车开放平台?</h2>
          <p>
            下载
            <a href="/static/doc/智慧停车开放平台接入申请单.xlsx">智慧停车开放平台接入申请单.xlsx</a>,填写相关信息后发送邮件到
            <a href="mailto:faz@akeparking.cn">faz@akeparking.cn</a>,智慧停车开放平台审核通过后会发送生产环境和测试环境的相关信息到您的邮箱上。
            <!-- 如何快速接入容联云通讯平台服务？仅需4步接入，15分钟即可使用：<br> (1)注册账号：填写注册信息，完成注册成为开发者；
                                        <br> (2)创建应用：注册时，系统已经创建了默认应用，还可以结合业务需求，创建自己的应用；
                                        <br> (3)对接测试：调用云通讯平台免费开放接口，对接平台联调测试
                                        <br> (4)上线运营：完成企业认证或个人认证，即可将应用上线正式使用（默认应用在认证完成时自动上线）。 -->
          </p>


        </div>
        <div class="item">
          <h2>如何调试上报类接口?</h2>
          <p>
            进出场上报请使用进场模拟/出场模拟接口，其它接口调试暂时请联系智慧停车开放平台研发团队。
            <!-- 智慧停车开放平台是一个平台，通过将复杂的通讯功能封装成SDK和API接口， 为合作伙伴提供IM、音频、视频、会议 呼叫中心、短信、流量等通讯能力及服务。 云通讯提供了近300个免费接口供合作伙伴调用，可以轻松实现即时通信（IM）、语音通话、语音通知、语音对讲、语 音会议、视频通话、视频会议、呼叫中心、智能IVR等20多种专业通讯功能。 -->
          </p>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Foot from '../components/Foot.vue'
import common from '../assets/js/common.js'


export default {
  mixins: [common],
  components: {
    Foot: Foot,
  },
  data() {
    return {
      customHelp: '',
    };
  },
  created() {
    if (this.$root.customConfig.help && Object.keys(this.$root.customConfig.help).length > 0) {
      this.customHelp = this.$root.customConfig.help;
    }
  },
  mounted() {
    let _this = this;
    _this.innitHeight();
    $(window).resize(function() {
      _this.innitHeight();
    });
  },
  methods: {
    innitHeight() {
      let helpHeight = $(window).height() - $(".head").height();
      let comtentHeight = $('.comtent').outerHeight();
      console.log("helpHeight, comtentHeight", helpHeight, comtentHeight)
      let height = helpHeight > comtentHeight ? helpHeight : comtentHeight;
      $(".help").height(height)
    },
    jump() {
      window.open("/Api");
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '../assets/less/var.less';

.help {
  position: relative;
  .Foot {
    position: absolute;
    bottom: 0;
  }
  .comtent {
    padding: 50px 0px 180px 0px;
    max-width: 960px;
    width: 80%;
    margin: 0 auto;
    box-sizing: border-box;
    .helpMsg {
      padding: 20px 100px 50px 35px;
      box-sizing: border-box;
      min-height: 480px;
      background: @bgc;
      border: @bdr;
      .item {
        h2 {
          // font-family: @contT6;
          font-size: 16px;
          color: rgba(17, 27, 41, 0.78);
          letter-spacing: 0;
          line-height: 16px;
          margin: 20px 0 10px 0;
        }
        p {
          // font-family: HiraginoSansGB-W3;
          font-size: 14px;
          color: rgba(17, 27, 41, 0.78);
          letter-spacing: 0;
          line-height: 26px;
          text-align: justify;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Help.vue